// Form configurations
export { projectInformationFormConfig } from './form-config';

// Title and navigation configurations
export {
  projectInformationTitle,
  projectInformationOptiontitle
} from './title-configs';
